/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export const GET_INTERFACES = 'GET_INTERFACES';
export const GET_INTERFACES_SUCCESS = 'GET_INTERFACES_SUCCESS';
export const GET_INTERFACES_FAILURE = 'GET_INTERFACES_FAILURE';

export const GET_DRAFT_INTERFACE_DETAILS = 'GET_DRAFT_INTERFACE_DETAILS';
export const GET_DRAFT_INTERFACE_DETAILS_SUCCESS = 'GET_DRAFT_INTERFACE_DETAILS_SUCCESS';
export const GET_DRAFT_INTERFACE_DETAILS_FAILURE = 'GET_DRAFT_INTERFACE_DETAILS_FAILURE';

export const GET_DRAFT_SCHEMA_RESOURCE_DETAILS = 'GET_DRAFT_SCHEMA_RESOURCE_DETAILS';
export const GET_DRAFT_SCHEMA_RESOURCE_DETAILS_SUCCESS =
  'GET_DRAFT_SCHEMA_RESOURCE_DETAILS_SUCCESS';
export const GET_DRAFT_SCHEMA_RESOURCE_DETAILS_FAILURE =
  'GET_DRAFT_SCHEMA_RESOURCE_DETAILS_FAILURE';

export const GET_DRAFT_SCHEMA_CONTENT_DETAILS = 'GET_DRAFT_SCHEMA_CONTENT_DETAILS';
export const GET_DRAFT_SCHEMA_CONTENT_DETAILS_SUCCESS = 'GET_DRAFT_SCHEMA_CONTENT_DETAILS_SUCCESS';
export const GET_DRAFT_SCHEMA_CONTENT_DETAILS_FAILURE = 'GET_DRAFT_SCHEMA_CONTENT_DETAILS_FAILURE';

export const GET_DRAFT_DEVICE_TYPES = 'GET_DRAFT_DEVICE_TYPES';
export const GET_DRAFT_DEVICE_TYPES_SUCCESS = 'GET_DRAFT_DEVICE_TYPES_SUCCESS';
export const GET_DRAFT_DEVICE_TYPES_FAILURE = 'GET_DRAFT_DEVICE_TYPES_FAILURE';

export const START_INTERFACE_DETAILS_EDIT_MODE = 'START_INTERFACE_DETAILS_EDIT_MODE';
export const CANCEL_INTERFACE_DETAILS_EDIT_MODE = 'CANCEL_INTERFACE_DETAILS_EDIT_MODE';

export const SAVE_INTERFACE_DETAILS_EDITS = 'SAVE_INTERFACE_DETAILS_EDITS';
export const SAVE_INTERFACE_DETAILS_EDITS_SUCCESS = 'SAVE_INTERFACE_DETAILS_EDITS_SUCCESS';
export const SAVE_INTERFACE_DETAILS_EDITS_FAILURE = 'SAVE_INTERFACE_DETAILS_EDITS_FAILURE';

export const GET_INTERFACE_DIFF = 'GET_INTERFACE_DIFF';
export const GET_INTERFACE_DIFF_SUCCESS = 'GET_INTERFACE_DIFF_SUCCESS';
export const GET_INTERFACE_DIFF_FAILURE = 'GET_INTERFACE_DIFF_FAILURE';

export const GET_DEVICETYPE_DIFF = 'GET_DEVICETYPE_DIFF';
export const GET_DEVICETYPE_DIFF_SUCCESS = 'GET_DEVICETYPE_DIFF_SUCCESS';
export const GET_DEVICETYPE_DIFF_FAILURE = 'GET_DEVICETYPE_DIFF_FAILURE';

export const CLEAR_INTERFACE_DETAILS = 'CLEAR_INTERFACE_DETAILS';

export const CREATE_INTERFACE = 'CREATE_INTERFACE';
export const CREATE_INTERFACE_SUCCESS = 'CREATE_INTERFACE_SUCCESS';
export const CREATE_INTERFACE_FAILURE = 'CREATE_INTERFACE_FAILURE';

export const SHOW_CONFIRMATION_MODAL = 'SHOW_CONFIRMATION_MODAL';
export const HIDE_CONFIRMATION_MODAL = 'HIDE_CONFIRMATION_MODAL';

export const DELETE_DRAFT_INTERFACE = 'DELETE_DRAFT_INTERFACE';
export const DELETE_DRAFT_INTERFACE_SUCCESS = 'DELETE_DRAFT_INTERFACE_SUCCESS';
export const DELETE_DRAFT_INTERFACE_FAILURE = 'DELETE_DRAFT_INTERFACE_FAILURE';

export const VALIDATE_INTERFACE = 'VALIDATE_INTERFACE';
export const VALIDATE_INTERFACE_SUCCESS = 'VALIDATE_INTERFACE_SUCCESS';
export const VALIDATE_INTERFACE_FAILURE = 'VALIDATE_INTERFACE_FAILURE';

export const ACTIVATE_INTERFACE = 'ACTIVATE_INTERFACE';
export const ACTIVATE_INTERFACE_SUCCESS = 'ACTIVATE_INTERFACE_SUCCESS';
export const ACTIVATE_INTERFACE_FAILURE = 'ACTIVATE_INTERFACE_FAILURE';

export const DEACTIVATE_INTERFACE = 'DEACTIVATE_INTERFACE';
export const DEACTIVATE_INTERFACE_SUCCESS = 'DEACTIVATE_INTERFACE_SUCCESS';
export const DEACTIVATE_INTERFACE_FAILURE = 'DEACTIVATE_INTERFACE_FAILURE';

export const VALIDATE_DEVICETYPE = 'VALIDATE_DEVICETYPE';
export const VALIDATE_DEVICETYPE_SUCCESS = 'VALIDATE_DEVICETYPE_SUCCESS';
export const VALIDATE_DEVICETYPE_FAILURE = 'VALIDATE_DEVICETYPE_FAILURE';
